export const DOJO_FALLBACK_IMAGE = "/img/no-image.jpg";
export const DOJO_PLACEHOLDER_IMAGE = "/img/dojo_placeholder.jpg";

export function safeArray(value) {
  return Array.isArray(value) ? value : [];
}

export function toNumber(value, defaultValue = 0) {
  const number = Number(value);
  return Number.isFinite(number) ? number : defaultValue;
}

export function normalizeText(value = "") {
  return String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

export function sortDojosByOrder(rows) {
  return safeArray(rows)
    .slice()
    .sort((a, b) => {
      const orderA = toNumber(a?.dojo_ordre, 0);
      const orderB = toNumber(b?.dojo_ordre, 0);

      if (orderA !== orderB) return orderA - orderB;

      return String(a?.dojo_nom || "").localeCompare(
        String(b?.dojo_nom || ""),
        "fr"
      );
    });
}

export function normalizeOrderDojos(rows) {
  return sortDojosByOrder(rows).map((dojo, index) => ({
    ...dojo,
    dojo_ordre: index + 1,
  }));
}

export function filterDojos(dojos, filters) {
  const query = normalizeText(filters?.query || "");

  return sortDojosByOrder(dojos).filter((dojo) => {
    if (!query) return true;

    const searchable = normalizeText(
      `${dojo?.dojo_nom || ""} ${dojo?.dojo_discipline || ""} ${
        dojo?.dojo_adresse || ""
      }`
    );

    return searchable.includes(query);
  });
}

export function calculateDojosStats(dojos) {
  const rows = safeArray(dojos);

  const disciplines = new Set();
  let withPhoto = 0;
  let withoutPhoto = 0;
  let withoutAddress = 0;

  for (const dojo of rows) {
    if (dojo?.dojo_discipline) disciplines.add(dojo.dojo_discipline);

    if (dojo?.dojo_photoURL) withPhoto += 1;
    else withoutPhoto += 1;

    if (!String(dojo?.dojo_adresse || "").trim()) withoutAddress += 1;
  }

  return {
    total: rows.length,
    disciplinesCount: disciplines.size,
    withPhoto,
    withoutPhoto,
    withoutAddress,
  };
}

export function getNextDojoOrder(dojos) {
  return safeArray(dojos).reduce((max, dojo) => {
    return Math.max(max, toNumber(dojo?.dojo_ordre, 0));
  }, 0) + 1;
}

export function getDefaultDojoForm(order = 1) {
  return {
    id: "",
    dojo_nom: "",
    dojo_discipline: "",
    dojo_adresse: "",
    dojo_photoURL: "",
    dojo_ordre: order,
  };
}

export function mapDojoToForm(dojo, order = 1) {
  if (!dojo) return getDefaultDojoForm(order);

  return {
    id: dojo?.id || "",
    dojo_nom: dojo?.dojo_nom || "",
    dojo_discipline: dojo?.dojo_discipline || "",
    dojo_adresse: dojo?.dojo_adresse || "",
    dojo_photoURL: dojo?.dojo_photoURL || "",
    dojo_ordre: dojo?.dojo_ordre ?? order,
  };
}

export function buildDojoPayload(formData, fallbackPhoto = DOJO_PLACEHOLDER_IMAGE) {
  return {
    id: formData?.id || undefined,
    dojo_nom: String(formData?.dojo_nom || "").trim(),
    dojo_discipline: String(formData?.dojo_discipline || "").trim(),
    dojo_adresse: String(formData?.dojo_adresse || "").trim(),
    dojo_photoURL: String(formData?.dojo_photoURL || "").trim() || fallbackPhoto,
    dojo_ordre: toNumber(formData?.dojo_ordre, 0),
  };
}

export function validateDojoPayload(payload) {
  if (!payload.dojo_nom) return "Le nom du dojo est requis.";
  if (!payload.dojo_discipline) return "La discipline est requise.";
  if (!payload.dojo_adresse) return "L’adresse est requise.";
  if (!Number.isFinite(Number(payload.dojo_ordre))) {
    return "L’ordre d’affichage doit être un nombre.";
  }

  return "";
}

export function validateImageFile(file) {
  if (!file) return "";

  const validType = /^image\/(png|jpe?g|webp)$/i.test(file.type);

  if (!validType) {
    return "Format image non supporté. Utilisez PNG, JPG ou WEBP.";
  }

  if (file.size > 10 * 1024 * 1024) {
    return "Image trop volumineuse. Taille maximale : 10 Mo.";
  }

  return "";
}